import { useState, useEffect } from "react";
import { AiOutlineThunderbolt } from "react-icons/ai";
import { FiPause, FiPlay } from "react-icons/fi";
import { GrUndo, GrDocumentCsv, GrDocumentPdf } from "react-icons/gr";
import { IoArrowBackOutline, IoCodeSlash } from "react-icons/io5";
import { LuRedo2, LuStarOff, LuEraser } from "react-icons/lu";
import {
  TbDatabasePlus,
  TbDatabase,
  TbExchange,
  TbArrowsSort,
} from "react-icons/tb";
import { PiShootingStar } from "react-icons/pi";
import { MdDownload } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ActionCreators } from "redux-undo";
import { FaRegFileImage } from "react-icons/fa";
import { Dropdown } from "flowbite-react";
import { IoMdArrowDropdown } from "react-icons/io";
import { useGetDatasourceQuery } from "../../../dataSource/sql/TablesourceApiSlice";
import {
  CreateSheet,
  getL1SheetProperty,
  getWorkbookProperty,
  resetSheet,
  updateL1Property,
} from "../../WorkbookSlice";
import AreYouSureModal from "./AreYouSureModal";
import {
  getAside2components,
  getChartDetails,
  getDefaultReduxState,
} from "../../../../middleware/getVizDetails";
import { buildCustomization } from "../../../../middleware/buildInitialSheetState";
import { useGetSqlQueryMutation } from "../../dataApiSlice";
import { getSheetControls } from "../../WorkbookControllingSlice";

export default function Header2({
  pause,
  animationOff,
  actionModal,
  sortModal,
  handlePlayPause,
  handleAnimatation,
  setActionModal,
  setSortModal,
  currentSheetIsDashboard,
  handleCallFunction,
  currentSheet,
  handleModal,
  VizType,
  isAside4Visible,
  setIsAside4Visible,
  Sheetid,
  setDataSourceModal,
  roles,
  setSqlModal,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changeDsModal, setChangeDSModal] = useState(false);
  const [dataSource, setDataSource] = useState(null);
  let connnectedDataSets = null;
  const dataSourcesArray = useSelector((state) =>
    getWorkbookProperty(state, "dataSources")
  );
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );
  // console.log(currentSheet);
  // // console.log(roles);

  const sheetQuery = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "query")
  );
  // // console.log(dataSource);

  // // console.log(sheetQuery);

  function renderIcon(VizType) {
    const chartDetails = getChartDetails(VizType);
    return chartDetails?.icon;
  }

  const {
    data: dataSets,
    isLoading: isDataSetsLoading,
    isError: isDataSetsError,
    error: dataSetsError,
    isSuccess: isDataSetsSuccess,
  } = useGetDatasourceQuery();

  if (isDataSetsSuccess) {
    connnectedDataSets = dataSets.filter((dSet) =>
      dataSourcesArray.some((arrayItem) => dSet.id === arrayItem)
    );
  }

  const hanldeChangeDataSource = (id) => {
    const selectOption = dataSets.find((dSet) => dSet.id === id);
    console.log(selectOption);
    if (selectOption) {
      const hasValues = Object.values(sheetQuery).some(
        (arr) => Array.isArray(arr) && arr.length
      );
      // console.log(hasValues);
      if (!hasValues) {
        dispatch(
          updateL1Property({
            SheetId: Sheetid,
            key: "dataSourceID",
            value: id,
          })
        );
      } else {
        setChangeDSModal(true);
      }
      setDataSource({
        NickName: selectOption.NickName,
        id: selectOption.id,
      });
    }
  };

  const selectOption = dataSets
    ? dataSets.find((dSet) => dSet.id === dataSourceID)
    : null;

  const handleSetDataSource = () => {
    const hasValues = Object.values(sheetQuery).some(
      (arr) => Array.isArray(arr) && arr.length
    );

    // console.log(hasValues);
    if (dataSource.id) {
      if (!hasValues) {
        // this will change the current sheet's dataSourceID
        dispatch(
          updateL1Property({
            SheetId: Sheetid,
            key: "dataSourceID",
            value: dataSource.id,
          })
        );
        setChangeDSModal(false);
      } else {
        // this will create a new sheet with new dataDourceID
        dispatch(
          CreateSheet({
            isDataSourceChanging: true,
            Action: "CreateSheet",
            newDataSourceID: dataSource.id,
          })
        );
      }
      setChangeDSModal(false);
    }
  };

  const handleResetSheet = () => {
    const sheet = getDefaultReduxState({ vizType: VizType }).newSheetState;

    const actions = {
      onClick: {},
      onDoubleClick: {},
      sort: [],
      quickTable: [],
    };

    const { CustomizeArrayComponents } = getAside2components(VizType);

    let customizationObject = buildCustomization(CustomizeArrayComponents);
    dispatch(
      resetSheet({
        Sheetid,
        query: sheet["query"],
        customization: customizationObject,
        actions,
      })
    );
  };
  const transposeColumns = () => {
    const { rows, groupByFields } = sheetQuery;
    // console.log(rows);
    // console.log(groupByFields);
    const newQuery = {
      ...sheetQuery,
      rows: groupByFields,
      groupByFields: rows,
    };
    // console.log(newQuery);

    dispatch(
      updateL1Property({ SheetId: Sheetid, key: "query", value: newQuery })
    );
  };
  const handleSQLQuery = () => {
    setSqlModal(true);
  };
  const iconButtons = [
    {
      name: "Go Back",
      icon: (
        <IoArrowBackOutline className="text-xl text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => navigate("/datasource"),
      show: true,
      tooltip: "data source page",
    },
    {
      name: "clearSheet",
      icon: (
        <LuEraser className="text-[20px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handleResetSheet,
      show: true,
      tooltip: "reset your sheet",
    },
    {
      name: "Undo",
      icon: (
        <GrUndo className="text-xl text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => dispatch(ActionCreators.undo()),
      show: true,
      tooltip: "undo",
    },
    {
      name: "Redo",
      icon: (
        <LuRedo2 className="text-xl text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => dispatch(ActionCreators.redo()),
      show: true,
      tooltip: "redo",
    },
    {
      name: pause ? "Play" : "Pause",
      icon: pause ? (
        <FiPlay className="text-[22px] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ) : (
        <FiPause className="text-[22px] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handlePlayPause,
      show: VizType !== "cordinatemap",
      tooltip: pause ? "play query" : "pause query",
    },
    {
      name: animationOff ? "Enable Animation" : "Disable Animation",
      icon: animationOff ? (
        <PiShootingStar className="text-[23px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ) : (
        <LuStarOff className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handleAnimatation,
      show: true,
      tooltip: animationOff ? "animation off" : "animation on",
    },
    {
      name: "Actions",
      icon: (
        <AiOutlineThunderbolt className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => setActionModal(!actionModal),
      show: VizType !== "simpleTable",
      tooltip: "actions",
    },
    {
      name: "Sort",
      icon: (
        <TbArrowsSort className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => setSortModal(!sortModal),
      show: ![
        "treechart",
        "radarchart",
        "cordinatemap",
        "areamap",
        "scatterchart",
      ].includes(VizType),
      tooltip: "sort",
    },
    {
      name: "transpose",
      icon: (
        <TbExchange className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: transposeColumns,
      show: true,
      tooltip: "transpose columns from Rows to Columns and Columns to Rows",
    },
    {
      name: "sql Query",
      icon: (
        <IoCodeSlash className="text-[22px] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handleSQLQuery,
      show: true,
      tooltip: "sql query",
    },
  ];
  return (
    <>
      <header className="bg-gray-200 h-[38px] px-2 flex items-center justify-between text-black ml-[1px] w-[99.85%] rounded min-h-[38px] z-20">
        <div className="flex items-center justify-between gap-4 relative">
          {iconButtons
            .filter((btn) => btn.show)
            .map((btn, idx) => (
              <div key={idx} title={btn.tooltip}>
                <div onClick={btn.onClick}>{btn.icon}</div>
              </div>
            ))}
        </div>

        {!currentSheetIsDashboard && (
          <div className="flex items-center justify-center gap-5 relative right-[0.5%]">
            {/* add or change dataSources */}
            <div className="relative">
              <Dropdown
                label={
                  <button
                    className="text-black flex items-center rounded justify-between w-48 max-w-60 truncate border border-gray-400 hover:border-blue-950 bg-transparent px-1 py-[2px]"
                    title="change data sources"
                  >
                    <span className="flex items-center justify-start gap-2">
                      {" "}
                      <TbDatabase className="text-blue-950" />
                      {selectOption !== undefined &&
                        selectOption !== null &&
                        selectOption.NickName}
                    </span>
                    <IoMdArrowDropdown className="text-xl text-black" />
                  </button>
                }
                arrowIcon={false}
                dismissOnClick={true}
                className="shadow-lg"
              >
                <div
                  className={`${
                    Array.isArray(connnectedDataSets) &&
                    connnectedDataSets.length > 3
                      ? "h-40"
                      : "h-auto"
                  }`}
                >
                  {Array.isArray(connnectedDataSets) &&
                  connnectedDataSets.length > 1
                    ? connnectedDataSets.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          className="flex w-full items-center justify-between px-2 py-1"
                          onClick={() => hanldeChangeDataSource(item.id)}
                        >
                          {item.NickName}
                        </Dropdown.Item>
                      ))
                    : null}

                  <Dropdown.Item
                    className="flex gap-2 w-full items-center justify-start px-2"
                    onClick={() => setDataSourceModal(true)}
                  >
                    <TbDatabasePlus /> new data source
                  </Dropdown.Item>
                </div>
              </Dropdown>
            </div>

            {/* download data */}
            <div className="relative">
              <Dropdown
                label={
                  <button
                    className="text-black flex items-center rounded justify-between w-48 max-w-60 truncate border border-gray-400 hover:border-blue-950 bg-transparent px-1 py-[2px]"
                    title="download"
                  >
                    <span className="flex items-center justify-start gap-2">
                      <MdDownload className="text-blue-950" /> Download
                    </span>
                    <IoMdArrowDropdown className="text-xl text-black" />
                  </button>
                }
                arrowIcon={false}
                dismissOnClick={true}
                className="shadow-lg"
              >
                <Dropdown.Item
                  className="flex gap-2 w-full items-center justify-start px-2 text-sm"
                  onClick={() => handleCallFunction(Sheetid, "csv")}
                >
                  <GrDocumentCsv /> Download .CSV
                </Dropdown.Item>
                <Dropdown.Item
                  className="flex gap-2 w-full items-center justify-start px-2 text-sm"
                  onClick={() => handleCallFunction(Sheetid, "image", "jpg")}
                >
                  <FaRegFileImage /> Download as image
                </Dropdown.Item>
                <Dropdown.Item
                  className="flex gap-2 w-full items-center justify-start px-2 text-sm"
                  onClick={() => handleCallFunction(Sheetid, "image", "pdf")}
                >
                  <GrDocumentPdf /> Download as pdf
                </Dropdown.Item>
              </Dropdown>
            </div>

            {/* change viz type */}
            <button
              className="bg-gray-200 font-bold rounded w-auto z-80 text-[14px] flex gap-2 justify-between items-center py-[2px] px-[8px] text-blue-950 border border-gray-400 hover:border-blue-950 truncate"
              disabled={!currentSheet.Sheetid}
              onClick={handleModal}
              title="visualization type"
            >
              {renderIcon(VizType)}
              Viz Type
            </button>
            {/* tauu */}
            {roles.includes("Creator") || roles.includes("Admin") ? (
              <button
                className="bg-gray-200 font-bold rounded text-[14px] flex gap-2 justify-center text-center items-center   text-blue-950 w-[2rem] h-[1.72rem] border border-gray-400 hover:border-blue-950"
                onClick={() => setIsAside4Visible(!isAside4Visible)}
                title="agent tauu"
              >
                <img
                  src="/images/moustache.png" // This path is relative to the public folder
                  alt="Tau"
                  className="w-full"
                />
              </button>
            ) : null}
          </div>
        )}
      </header>
      {changeDsModal ? (
        <AreYouSureModal
          message={
            "By changing the data source will create a new sheet with new data source"
          }
          closeModal={() => setChangeDSModal(false)}
          okayButton={handleSetDataSource}
        />
      ) : null}
    </>
  );
}
